import React from "react";
import './main.css';
import { useNavigate } from 'react-router-dom'; 
import axios from 'axios';   

const Main = () => {   
    let navigate = useNavigate();
 
  return ( 
    <> 
        <svg className="main__logo" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M23.2808 0C23.1599 9.72926 22.4958 15.1976 18.8467 18.8467C15.1976 22.4958 9.72928 23.1599 0 23.2808V24.7192C9.72929 24.8401 15.1976 25.5042 18.8467 29.1533C22.4958 32.8024 23.1599 38.2707 23.2808 48H24.7192C24.8401 38.2707 25.5042 32.8024 29.1533 29.1533C32.8024 25.5042 38.2707 24.8401 48 24.7192V23.2808C38.2707 23.1599 32.8024 22.4957 29.1533 18.8467C25.5042 15.1976 24.8401 9.72925 24.7192 0H23.2808Z" fill="white"/>
        </svg>
        <div className="main__titleMobile">Чей это Дзен</div>
        <div className="main__title">Угадай персонажа <br/>по ленте Дзена</div> 
        <div className="main__text">
            <p>По ленте в Дзене можно сказать о&nbsp;человеке всё. Ведь наши алгоритмы точно знают, что тебе интересно. А что, если бы у известных персонажей была своя лента в Дзене? <span>Кто читал бы контент про химические эксперименты: Томас Эдисон, Дмитрий Менделеев или Михаил Ломоносов? А кто ставил бы лайки на ролики про макияж: Афродита, Золушка или Клеопатра?</span></p>            
            <p>Угадай по контенту, кому принадлежит лента Дзена, и участвуй в розыгрыше призов от авторов!</p>
        </div>   
        <button className="btn main__btn" type="button" onClick={()=>{ 
            window["ym"](88899563,'reachGoal','game_guess_who_СlickStart'); 
            axios.get('/api.php', { params: { ip: window.ip, key: 'start' } });
            return navigate("../question", { replace: false }); 
        }}>Играть</button> 
    </>
  );
};

export default Main;
